import { apiV2 } from "../v2";
import { adminUserIdRequest } from "./users.dto";
import {
  adminCollectionsResponse,
  adminFollowRequest,
  adminFollowsResponse,
  listAdminCollectionItemsRequest,
  listAdminCollectionItemsResponse,
  listAdminReadsRequest,
  listAdminReadsResponse,
} from "./usersData.dto";

export const listAdminUserFollowsApi = apiV2("GET", "/admin/users/:id/follows").withRequest(adminUserIdRequest).withResponse(adminFollowsResponse);

export const followAdminUserApi = apiV2("PUT", "/admin/users/:id/follows/:alias").withRequest(adminFollowRequest).withResponse(adminFollowsResponse);

export const unfollowAdminUserApi = apiV2("DELETE", "/admin/users/:id/follows/:alias").withRequest(adminFollowRequest).withResponse(adminFollowsResponse);

export const listAdminUserReadsApi = apiV2("GET", "/admin/users/:id/reads").withRequest(listAdminReadsRequest).withResponse(listAdminReadsResponse);

export const listAdminUserCollectionsApi = apiV2("GET", "/admin/users/:id/collections").withRequest(adminUserIdRequest).withResponse(adminCollectionsResponse);

export const listAdminCollectionItemsApi = apiV2("GET", "/admin/users/:id/collections/:collectionId/items")
  .withRequest(listAdminCollectionItemsRequest)
  .withResponse(listAdminCollectionItemsResponse);
